import { Formik, Form } from 'formik';
import { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth.js';
import { setupAxiosInterceptors } from '../../config/axiosConfig.js';
import { LoginSchema } from '../../validation/loginValidation.js';
import { LOGIN_INITIAL_VALUES } from '../../constants/loginConstants.js';
import LoginForm from './LoginForm.js';

export default function LoginComponent() {
    useEffect(() => {
        setupAxiosInterceptors();
    }, []);

    const { passwordType, togglePassword, handleLogin } = useAuth();

    return (
        <div>
            <Formik
                initialValues={LOGIN_INITIAL_VALUES}
                validationSchema={LoginSchema}
                onSubmit={handleLogin}
            >
                {({ errors, touched, isSubmitting, handleReset }) => (
                    <Form data-testid='login-form'>
                        <div>
                            <LoginForm 
                                errors={errors}
                                touched={touched}
                                passwordType={passwordType}
                                togglePassword={togglePassword}
                                isSubmitting={isSubmitting}
                                handleReset={handleReset}
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}